import { Box, Button, Flex, Heading, useCheckboxGroup } from '@chakra-ui/react';
import {
  RecipeFavoriteTagResponse,
  RecipeTagsResponse,
} from '@diamond/shared/types';
import { useRouteQuery } from '@diamond/sol-buyer/utils';
import cleanDeep from 'clean-deep';
import { useRouter } from 'next/router';

import { RecipeListCategoryCheckbox } from './RecipeListCategoryCheckbox';

type RecipeListFilterCategoriesProps = {
  categories: RecipeTagsResponse | RecipeFavoriteTagResponse;
  inFavorite?: boolean;
};

export function RecipeListFilterCategory({
  categories,
  inFavorite = false,
}: RecipeListFilterCategoriesProps) {
  const router = useRouter();
  const routeQuery = useRouteQuery();
  const tags = routeQuery?.['tags'] as string[];

  const { getCheckboxProps } = useCheckboxGroup({
    value: Array.isArray(routeQuery?.['tags'])
      ? routeQuery?.['tags']
      : [routeQuery?.['tags']],
    onChange(value: string[]) {
      router.replace(
        {
          pathname: router.pathname,
          query: cleanDeep({
            ...routeQuery,
            tags: Array.isArray(value) ? value : [value],
          }),
        },
        undefined,
        { shallow: true }
      );
    },
  });

  const handleReset = () => {
    const { tags, ...restQuery } = routeQuery;
    router.push(
      {
        pathname: router.pathname,
        query: restQuery,
      },
      undefined,
      { shallow: true }
    );
  };

  return inFavorite ? (
    <>
      {categories.data.map((c) => (
        <RecipeListCategoryCheckbox
          key={c.id}
          {...getCheckboxProps({ value: c.id })}
          label={c.name}
          icon={c.small_icon_url}
          count={'count' in c ? c.count : 0}
          bgColor={c.bg_color}
          textColor={c.text_color}
          type="favorite"
        />
      ))}
    </>
  ) : (
    <>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        mb={{ base: '0', md: '2' }}
      >
        <Heading fontWeight="semibold" fontSize={{ base: 'sm', md: 'lg' }}>
          Kategori
        </Heading>
        {tags ? (
          <Button
            variant="ghost"
            bg="transparent"
            size="xs"
            onClick={handleReset}
          >
            Atur Ulang
          </Button>
        ) : null}
      </Flex>
      <Box
        display={{ base: 'flex', md: 'grid' }}
        overflow={{ base: 'scroll', lg: 'unset' }}
        pt="4"
        gridTemplateColumns={{ base: 'unset', md: 'repeat(auto-fill, 60px)' }}
        justifyContent={{ base: 'start', md: 'center' }}
        gap={{ base: '4', md: '12' }}
      >
        {categories.data.map((c) => (
          <RecipeListCategoryCheckbox
            key={c.id}
            {...getCheckboxProps({ value: c.id })}
            label={c.name}
            icon={c.big_icon_url}
            type="icon"
          />
        ))}
      </Box>
    </>
  );
}
